module.exports = __webpack_public_path__ + "img/ylb-3.e8bafe7d.png";